import { AimOutlined } from '@ant-design/icons'

export default {
  id: 'instance_profiling',
  routerPrefix: '/instance_profiling',
  icon: AimOutlined,
  reactRoot: () => import('.')
}
